import React from 'react';
import { VehicleCameraLayout } from 'core/models/layout';
import styled from '@emotion/styled';
import { MainScreenLayoutSettingPanel } from '../MainScreenLayoutSettingPanel';
import { SubScreenLayoutSettingPanel } from '../SubScreenLayoutSettingPanel';
import { fontFamily } from 'components/views/default';
import { MediaDevice, CameraDevice, MicrophoneDevice } from 'core/models/mediaDevice';

const Frame = styled.div({
    minWidth: '30em',
});

const TargetVehicle = styled.h1({
    fontFamily,
});

const VehicleName = styled.div({
    fontFamily,
    fontSize: 'x-large',
});

const VehicleId = styled.div({
    fontFamily,
    fontSize: 'medium',
    ':before': {
        content: '"id: "',
    }
});

const Separator = styled.hr({
    marginTop: '3em',
    marginBottom: '2em',
});

function replace<T>(values: T[], newValue: T, index: number) {
    return [
        ...values.slice(0, index),
        newValue,
        ...values.slice(index + 1),
    ];
}

export type CameraLayoutSettingPanelProps = {
    className?: string;
    vehicleId: string;
    vehicleName: string;
    cameraDevices: CameraDevice[] | undefined;
    microphoneDevices: MicrophoneDevice[] | undefined;
    layout: VehicleCameraLayout;
    onUpdate: (layout: VehicleCameraLayout) => void;
    getVideoConfig?: (mediaDeviceId: MediaDevice.Id) => Promise<Partial<MediaDevice.VideoConfig>>;
    putVideoConfig?: (mediaDeviceId: MediaDevice.Id, config: Partial<MediaDevice.VideoConfig>) => Promise<void>;
    getAudioConfig?: (mediaDeviceId: MediaDevice.Id) => Promise<Partial<MediaDevice.AudioConfig>>;
    putAudioConfig?: (mediaDeviceId: MediaDevice.Id, config: Partial<MediaDevice.AudioConfig>) => Promise<void>;
}

export function CameraLayoutSettingPanel(props: CameraLayoutSettingPanelProps) {
    const { vehicleId, vehicleName, cameraDevices, microphoneDevices, layout, onUpdate, getVideoConfig, putVideoConfig, getAudioConfig, putAudioConfig } = props;

    function onCheckedUpdate(layout: VehicleCameraLayout) {
        onUpdate(layout);
    }

    return (
        <Frame>
            <TargetVehicle>
                <VehicleName>{vehicleName}</VehicleName>
                <VehicleId>{vehicleId}</VehicleId>
            </TargetVehicle>
            <MainScreenLayoutSettingPanel
                cameraDevices={cameraDevices}
                microphoneDevices={microphoneDevices}
                layout={layout.mainscreen}
                onUpdate={mainscreen => onCheckedUpdate({ ...layout, mainscreen })}
                getVideoConfig={getVideoConfig}
                putVideoConfig={putVideoConfig}
                getAudioConfig={getAudioConfig}
                putAudioConfig={putAudioConfig}
            />
            {
                layout.subscreens.map((subscreen, i) =>
                    <React.Fragment key={i}>
                        <Separator />
                        <SubScreenLayoutSettingPanel
                            subscreenNumber={i + 1}
                            cameraDevices={cameraDevices}
                            layout={subscreen}
                            onUpdate={subscreen => onCheckedUpdate({ ...layout, subscreens: replace(layout.subscreens, subscreen, i) })}
                            getVideoConfig={getVideoConfig}
                            putVideoConfig={putVideoConfig}
                        />
                    </React.Fragment>
                )
            }
        </Frame>
    );
}
